import React from 'react';
import { motion } from 'framer-motion';
export function Footer() {
  return <footer className="w-full bg-jazugas-black text-white py-12 px-4" data-id="element-5">
      <div className="max-w-6xl mx-auto" data-id="element-6">
        <div className="flex flex-col items-center space-y-8" data-id="element-7">
          {/* Logo */}
          <motion.img src="https://cdn.magicpatterns.com/uploads/id3CX4wVnk64xtH8cNPcvd/Logo_Jazugas.png" alt="JAZUGAS Logo" className="h-20 w-auto" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-8" />

          {/* CTA */}
          <motion.a href="https://wa.me/50689925929" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-8 py-4 bg-jazugas-yellow text-jazugas-black font-semibold rounded-lg hover:bg-opacity-90 transition-all duration-300 shadow-lg hover:shadow-xl" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} aria-label="Aplicar por WhatsApp" data-id="element-9">
            <svg className="w-6 h-6 mr-2" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-10">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" data-id="element-11" />
            </svg>
            Aplicar por WhatsApp
          </motion.a>

          {/* Tagline */}
          <motion.p className="text-center text-gray-400 text-sm" initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} data-id="element-12">
            JAZUGAS - Líder en Costa Rica en Gas LP
          </motion.p>

          {/* Copyright */}
          <motion.p className="text-center text-gray-500 text-xs" initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.5
        }} data-id="element-13">
            © {new Date().getFullYear()} JAZUGAS. Todos los derechos
            reservados.
          </motion.p>
        </div>
      </div>
    </footer>;
}